import React from "react";
import { useEffect } from "react";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";

import Home from "./pages/Home";
import ThankYou from "./pages/thankyou";
import ThankYouRejected from "./pages/thankyou-ineligible";
import Header from "./components/Header";
import { pageViewEvent } from './services/adobeDataLayer'

function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, [])
  return (
    <>
      {/* update basename while pushing to UAT/LIVE {UAT: /v2/46725/lp/home-loan-bau-v3/, live:window.location.pathname } */}
      <Router basename={window.location.pathname}>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/thankyou-not-eligible" element={<ThankYouRejected />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
